// Component Name:  AddProduct component
// Author: Bharath
// Platform: Web
// OS: Windows
// IDE: Visual Studio Code
// Reference: Original
// Date:
// Description: This component is for add Charger Details.
// Dependencies: React,  Redux (for toast), API layer to add Image and create a charger
// Interfaces: Accepts props including selectedLocationId, locationSelected, email
// Maintenance History:  1.0 - First Version

// Edited by Lavanya S
// [28-04-2025] Integrated API layer.
// [28-04-2025] Added protocol type and rating dropdowns.
import React, { Component } from "react";
import { Container, Card, CardBody, Row, Nav, NavItem, NavLink, TabPane, TabContent, Col, Form, FormGroup, Label, Input, Button } from "reactstrap";
import { Link } from "react-router-dom";
import classnames from "classnames";
import Select from "react-select";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { addCharger, getChargerById } from "../../api/chargerAPI";
import { createImage } from "../../api/imageAPI";
import { connect } from "react-redux";
import { connectorsOptions, CURRENCY_MAP, modelTypeOptions, powerRatingOptions, VENDOR_ID } from "../Utility/Constants";
import { failureToast, warningToast } from "../../store/dbFilter/actions";
import { createChargerTab1Validation, createChargerTab3Validation, validateChargerId } from "../../api/utils/validateAPI";
import UploadImage from "../Utility/UploadImage";
import { convertToBase64, inputRequired } from "../Utility/utilsFunctions";
import { loadLocation } from "../../api/utils/loadLocations";
import { ActiveBtn, CancelBtn, InActiveBtn } from "../Utility/Button";

class AddProduct extends Component {
  constructor(props) {
    super(props);
    this.state = {
      breadcrumbItems: [
        { title: "Charger Management System", link: "#" },
        { title: "Add Charger", link: "#" },
      ],
      activeTab: 1,
      selectedFiles: [],
      charger: {
        name: "",
        chargerId: "",
        serialNumber: "",
        modelType: "",
        protocolType: "",
        currency: "INR",
        perUnitRate: 0,
        deploymentStatus: "",
        lastHeartbeat: "",
        locationId: "",
        rating: "",
        ocppId: "",
      },
      connectors: [],
      locationOptions: [],
    };
    this.toggleTab = this.toggleTab.bind(this);
  }
  async componentDidMount() {
    try {
      const data = await loadLocation(this.props.locationIds);
      this.setState({ locationOptions: data });
    } catch (e) {
      console.log("Error Images Data: ", e);
    }
  }
  validateTab1 = async () => {
    try {
      const { serialNumber, chargerId, name, locationId, connectors } = this.state.charger;
      await createChargerTab1Validation.validate({ serialNumber, chargerId, name, locationId, connectors });
      return true;
    } catch (err) {
      if (err.name === "ValidationError") {
        const msg = "Validation Error: " + err.errors.join(", ");
        this.props.warningToast({ title: "Validation", message: msg });
        return false;
      }
      this.props.failureToast({ title: "Error", message: "Unexpected Validation Error" });
    }
  };

  // vaidate the create charger tab 3
  validateTab3 = async () => {
    try {
      const { perUnitRate, ocppId, deploymentStatus } = this.state.charger;
      await createChargerTab3Validation.validate({ perUnitRate, ocppId, deploymentStatus });
      console.log("success");
      return true;
    } catch (err) {
      if (err.name === "ValidationError") {
        const msg = "Validation Error: " + err.errors.join(", ");
        this.props.warningToast({ title: "Validation", message: msg });
        return false;
      }
      this.props.failureToast({ title: "Error", message: "Unexpected Validation Error" });
    }
  };

  async toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      if (tab >= 1 && tab <= 3) {
        if (this.state.activeTab === 1 && (tab === 2 || tab === 3)) {
          const isValidated = await this.validateTab1();
          if (isValidated) {
            this.setState({
              activeTab: tab,
            });
          }
        } else {
          this.setState({
            activeTab: tab,
          });
        }
      }
    }
  }

  /**
   * Makes a call to create a new charger or update the existing one
   * @param {object} charger - valid json data
   * @returns - returns charger data
   */
  handleCreateCharger = async (image = "") => {
    try {
      const chargerDetails = { ...this.state.charger, connectors: this.state.connectors, imageId: image, hostId: this.props.email, vendorId: VENDOR_ID };
      console.log("chargerDetails: ", chargerDetails);

      await addCharger(chargerDetails);
      this.resetChargerData();
    } catch (err) {
      console.log("Error creating/updating chargers: ", err.msg);
    }
  };

  /**
   * Makes a call to create a new Image or update the existing one
   * @returns - returns Image data
   */
  handleCreateImage = async () => {
    try {
      const isValidated = await this.validateTab3();
      if (isValidated) {
        const base64 = await convertToBase64(this.state.selectedFiles[0]?.base64);
        const imgDetail = { filename: this.state.selectedFiles[0]?.name, data: base64 };
        const response = await createImage(imgDetail);
        const { message, data } = response;
        console.log(`${message}`, data);
        this.handleCreateCharger(data);
      }
    } catch (err) {
      console.log("Error creating/updating Images: ", err.msg);
    }
  };

  resetChargerData = () => {
    this.setState({
      charger: {
        name: "",
        chargerId: "",
        serialNumber: "",
        modelType: "",
        protocolType: "",
        currency: "INR",
        perUnitRate: 0,
        deploymentStatus: "",
        ocppId: "",
        locationId: "",
        imageId: "",
        ocppId: "",
        rating: "",
      },
      selectedFiles: [],
    });
    this.setState((prevState) => ({
      connectors: {
        ...prevState.connectors,
        connectorType: [],
      },
    }));
    this.toggleTab(1);
  };
  handleFormChange = (e) => {
    const { name, value } = e.target;
    if (value === "add-new-location") {
      this.props.history.push("/cms-add-locations");
    } else {
      // Handle other form changes normally
      this.setState({
        charger: {
          ...this.state.charger,
          [name]: value,
        },
      });
    }
  };
  handleSelectChange = (selectedOptions) => {
    let newConnector = [];
    if (selectedOptions && selectedOptions.length > 0) {
      let i = 0;
      selectedOptions.forEach((option) => {
        newConnector.push({ connectorId: ++i, connectorType: option.value });
      });
      this.setState({ connectors: newConnector });
    }
  };
  handleRemoveImage = () => {
    this.setState({ selectedFiles: [] });
  };
  render() {
    const { name, chargerId, serialNumber, modelType, protocolType,  perUnitRate, deploymentStatus, ocppId, locationId, rating } = this.state.charger;

    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs title="Add Charger" breadcrumbItems={this.state.breadcrumbItems} />

            <Row>
              <Col lg={12}>
                <Card>
                  <CardBody>
                    <div id="addproduct-nav-pills-wizard" className="twitter-bs-wizard">
                      <Nav pills justified className="twitter-bs-wizard-nav">
                        <NavItem>
                          <NavLink
                            onClick={() => this.toggleTab(1)}
                            className={classnames({
                              active: this.state.activeTab === 1,
                            })}
                          >
                            <span className="step-number">01</span>
                            <span className="step-title">Basic Info</span>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            onClick={() => this.toggleTab(2)}
                            className={classnames({
                              active: this.state.activeTab === 2,
                            })}
                          >
                            <span className="step-number">02</span>
                            <span className="step-title">Charger Img</span>
                          </NavLink>
                        </NavItem>

                        <NavItem>
                          <NavLink
                            onClick={() => this.toggleTab(3)}
                            className={classnames({
                              active: this.state.activeTab === 3,
                            })}
                          >
                            <span className="step-number">03</span>
                            <span className="step-title">Configuration</span>
                          </NavLink>
                        </NavItem>
                      </Nav>
                      <TabContent activeTab={this.state.activeTab} className="twitter-bs-wizard-tab-content">
                        {/* Tab 1 basic Information */}
                        <TabPane tabId={1}>
                          <h4 className="card-title">Basic Information</h4>
                          <p className="card-title-desc">Fill all information below</p>

                          <Form>
                            <Row>
                              <Col md={6}>
                                <FormGroup>
                                  <Label htmlFor="locationId">Location{inputRequired()}</Label>
                                  <select id="locationId" name="locationId" type="text" className="form-control" value={locationId} onChange={this.handleFormChange}>
                                    <option value="">Select Location</option>
                                    {this.state?.locationOptions?.length > 0 &&
                                      this.state?.locationOptions?.map((item) => (
                                        <option value={item?.id} key={item?.id}>
                                          {item?.name}
                                        </option>
                                      ))}
                                    <option value="add-new-location">+ Add Location</option>
                                  </select>
                                </FormGroup>
                              </Col>
                              <Col md={6}>
                                <FormGroup>
                                  <Label htmlFor="name">Name{inputRequired()}</Label>
                                  <Input id="name" name="name" type="text" className="form-control" value={name} onChange={this.handleFormChange} />
                                </FormGroup>
                              </Col>
                            </Row>

                            <Row>
                              <Col md={6}>
                                <FormGroup>
                                  <Label htmlFor="chargerId">Charger Id{inputRequired()}</Label>
                                  <Input id="chargerId" name="chargerId" type="text" className="form-control" value={chargerId} onChange={this.handleFormChange} />
                                </FormGroup>
                              </Col>
                              <Col lg={6}>
                                <FormGroup>
                                  <Label htmlFor="serialNumber">Hardware Serial Number{inputRequired()}</Label>
                                  <Input id="serialNumber" name="serialNumber" type="text" className="form-control" value={serialNumber} onChange={this.handleFormChange} />
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg={6}>
                                <FormGroup>
                                  <Label htmlFor="modelType">Model Type</Label>
                                  <select id="modelType" name="modelType" className="form-control select2" value={modelType} onChange={this.handleFormChange}>
                                    <option value="">Select Model Type</option>
                                    {modelTypeOptions?.map((item) => (
                                      <option value={item?.label}>{item?.label}</option>
                                    ))}
                                  </select>
                                </FormGroup>
                              </Col>
                              {/*  */}
                              <Col md={6}>
                                <FormGroup>
                                  <Label className="control-label">Connectors</Label>
                                  <Select
                                    isMulti
                                    name="features"
                                    options={connectorsOptions}
                                    className="select2 select2-multiple"
                                    value={this.state.connectors?.connectorType}
                                    onChange={this.handleSelectChange}
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row></Row>
                          </Form>
                        </TabPane>
                        {/* Tab 2 Upload image */}
                        <TabPane tabId={2}>
                          <h4 className="card-title">Charger Images</h4>
                          <p className="card-title-desc">Upload Charger image</p>
                          <UploadImage selectedFiles={this.state.selectedFiles} setSelectedFiles={(data) => this.setState({ selectedFiles: data })} />
                        </TabPane>
                        {/* Tab 3 Charger Details */}
                        <TabPane tabId={3}>
                          <h4 className="card-title">Meta Data</h4>
                          <p className="card-title-desc">Fill all information below</p>

                          <Form>
                            <Row>
                              {/* <Col sm={6}>
                                <FormGroup>
                                  <Label htmlFor="firmwareVersion">Firmware Version</Label>
                                  <Input
                                    id="firmwareVersion"
                                    name="firmwareVersion"
                                    type="text"
                                    className="form-control"
                                    value={firmwareVersion}
                                    onChange={this.handleFormChange}
                                  />
                                </FormGroup>
                              </Col> */}

                              <Col md={12}>
                                <FormGroup>
                                  <Label className="control-label" htmlFor="ocppId">
                                    OCPP Id{inputRequired()}
                                  </Label>
                                  <Input id="ocppId" name="ocppId" type="text" className="form-control" value={ocppId} onChange={this.handleFormChange} />
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col md={6}>
                                <FormGroup>
                                  <Label htmlFor="protocolType">Protocol Type{inputRequired()}</Label>
                                  <select id="protocolType" name="protocolType" className="form-control select2" value={protocolType} onChange={this.handleFormChange}>
                                    <option value="">Select Protocol Type</option>
                                    <option value="OCPP1.6">OCPP1.6</option>
                                    <option value="OCPP2.0">OCPP2.0</option>
                                  </select>
                                </FormGroup>
                              </Col>
                              <Col md={6}>
                                <FormGroup>
                                  <Label htmlFor="deploymentStatus">Deployment Status{inputRequired()}</Label>
                                  <select id="deploymentStatus" name="deploymentStatus" className="form-control select2" value={deploymentStatus} onChange={this.handleFormChange}>
                                    <option value="">Select Deployment Status</option>
                                    <option value="Active">Active</option>
                                    <option value="Inactive">Inactive</option>
                                  </select>
                                </FormGroup>
                              </Col>
                            </Row>

                            <Row>
                              {/* <Col sm={4}>
                                <FormGroup>
                                  <Label htmlFor="metatitle">Currency *</Label>
                                  <select id="currency" name="currency" type="text" className="form-control" value={currency} onChange={this.handleFormChange}>
                                    <option>Select Currency</option>
                                    <option>Indian Rupee (₹)</option>
                                    <option>USD ($)</option>
                                    <option>Euro (€)</option>
                                    <option>Pound (£)</option>
                                    <option>AED (د.إ)</option>
                                  </select>
                                </FormGroup>
                              </Col> */}

                              <Col sm={6}>
                                <FormGroup>
                                  <Label htmlFor="metatitle">Unit Price ( 0 - promotional){inputRequired()}</Label>
                                  <Input
                                    id="perUnitRate"
                                    placeholder="0"
                                    name="perUnitRate"
                                    type="number"
                                    className="form-control"
                                    value={perUnitRate}
                                    onChange={this.handleFormChange}
                                    min={1}
                                  />
                                </FormGroup>
                              </Col>
                              <Col sm={6}>
                                <FormGroup>
                                  <Label className="control-label" htmlFor="rating">
                                    Rating
                                  </Label>
                                  <select id="rating" name="rating" className="form-control select2" value={rating} onChange={this.handleFormChange}>
                                    <option value="">Select Rating </option>
                                    {powerRatingOptions?.map((item) => (
                                      <option value={item?.label}>{item?.label}</option>
                                    ))}
                                  </select>
                                </FormGroup>
                              </Col>
                            </Row>
                          </Form>
                          {/* Submit or cancel the form details */}
                          <div className="d-flex justify-content-center mt-4">
                            <ActiveBtn name={"Add Charger"} handleClick={() => (this.state.selectedFiles?.length === 0 ? this.handleCreateCharger() : this.handleCreateImage())} />
                            <CancelBtn name={"Cancel"} handleClick={this.resetChargerData} />
                          </div>
                        </TabPane>
                      </TabContent>
                      {/* Previous and  next button for each tab*/}
                       <ul className={`pager wizard twitter-bs-wizard-pager-link ${this.props.layoutType === "vertical" ? "d-flex justify-content-between" : "d-flex flex-column justify-content-center align-items-center"}`}>
                        <li className="mb-2">
                          {this.state.activeTab === 1 ? (
                            <InActiveBtn name={"Previous"} />
                          ) : (
                            <ActiveBtn
                              name={"Previous"}
                              handleClick={() => {
                                this.toggleTab(this.state.activeTab - 1);
                              }}
                            />
                          )}
                        </li>

                        <li className="mb-2">
                          {this.state.activeTab === 3 ? (
                            <InActiveBtn name={"Next"} />
                          ) : (
                            <ActiveBtn
                              name={"Next"}
                              handleClick={() => {
                                this.toggleTab(this.state.activeTab + 1);
                              }}
                            />
                          )}
                        </li>
                      </ul>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => ({
  locationIds: state?.LocationManagement?.locationIds,
  chargerData: state?.ChargerManagement?.chargerData,
  email: state.Login.user.email,
  layoutType: state.Layout.layoutType,
});
const mapDispatchToProps = (dispatch) => ({
  failureToast: (payload) => dispatch(failureToast(payload)),
  warningToast: (payload) => dispatch(warningToast(payload)),
});
export default connect(mapStateToProps, mapDispatchToProps)(AddProduct);
